interface String {
    format(...replacements: string[]): string;
    capitalize(): string;
    atob(): string;
}

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };

    String.prototype.capitalize = function () {
        let result = this.replace(/(^|[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(?:([a-záéíóúüñ])|([A-ZÁÉÍÓÚÜÑ]))|([A-ZÁÉÍÓÚÜÑ]+)/gu, function (l) { return l.toUpperCase() });
        return result;
    };

    String.prototype.atob = function () {
        let code = this.replace(/-/g, '+').replace(/_/g, '/');
        return decodeURIComponent(Array.prototype.map.call(window.atob(code), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    }
}